import { styled } from 'css-literal-loader/styled';
import { navigate } from 'gatsby';
import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';
import Layout from '@4c/layout';

import { shippingDelayed, allowEventPickup } from '../../config.json';
import AddressForm from '../components/AddressForm';
import Form from '../components/Form';
import Heading from '../components/Heading';
import ServerErrorSummary from '../components/ServerErrorSummary';
import paths from '../paths';
import withReservation from '../utils/Reservation';
import styles from '../styles/responsive.module.scss';

const errorMessages = defineMessages({
  'invalid_stripe_request.taxes_calculation_failed': {
    id: 'taxCalculationFailed',
    defaultMessage:
      'Could not verify address, please ensure the city, state, and zip are correct',
  },
});

const ErrorSummary = styled(ServerErrorSummary, null, "ErrorSummary", require("./_shipping-information-ErrorSummary.module.scss"), "error-summary", "errorSummary");

const SubmitButton = styled(Form.SubmitButton, null, "SubmitButton", require("./_shipping-information-SubmitButton.module.scss"), "submit-button", "submitButton");

class ShippingInformation extends React.Component {
  state = { hasServerError: false, serverError: null };

  componentDidUpdate(_, prevState) {
    if (this.state.hasServerError && !prevState.hasServerError) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  }

  submitForm = async ({ eventPickup, ...shippingAddress }) => {
    const { cart } = this.props;
    try {
      await cart.setReservationCart(
        shippingAddress,
        eventPickup ? 'EVENT_PICKUP' : 'STANDARD_SHIPPING',
      );
    } catch (gqlError) {
      if (gqlError.details) {
        const serverError = []
          .concat(
            ...gqlError.details.map(d => d.upstream && d.upstream.errors),
          )
          .map(({ code }) => errorMessages[code])
          .find(Boolean);

        this.setState({ hasServerError: true, serverError });
      }
      return;
    }

    navigate(paths.payment);
  };

  render() {
    const { hasServerError, serverError } = this.state;
    return (
      <>
        {hasServerError && (
          <ErrorSummary>
            {serverError && <FormattedMessage {...serverError} />}
          </ErrorSummary>
        )}

        <Heading level="2" className={styles.textAlignCenterSm}>
          <FormattedMessage
            defaultMessage="Shipping Information"
            id="checkout.shippingDetails"
          />
          <small style={{ display: 'block' }}>
            {!shippingDelayed ? (
              <FormattedMessage
                defaultMessage="Delivered within 3-7 business days (USA Only)"
                id="checkout.shippingDetails"
              />
            ) : (
              <FormattedMessage
                defaultMessage="Delivered within 4 weeks (USA Only)"
                id="checkout.shippingDetailsLong"
              />
            )}
          </small>
        </Heading>
        <AddressForm
          isShipping
          withEventPickup={allowEventPickup}
          submitForm={this.submitForm}
          email={this.props.cart.email}
        >
          <Layout as={SubmitButton} alignSelf="flex-start">
            <FormattedMessage
              defaultMessage="Continue to Payment"
              id="checkout.shippingInformation.submit"
            />
          </Layout>
        </AddressForm>
      </>
    );
  }
}

export default withReservation(ShippingInformation);
